import { render, staticRenderFns } from "./TemplateGalleryFilters.vue?vue&type=template&id=46816472&scoped=true"
import script from "./TemplateGalleryFilters.vue?vue&type=script&lang=js"
export * from "./TemplateGalleryFilters.vue?vue&type=script&lang=js"
import style0 from "./TemplateGalleryFilters.vue?vue&type=style&index=0&id=46816472&prod&lang=scss&scoped=true"
import style1 from "./TemplateGalleryFilters.vue?vue&type=style&index=1&id=46816472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46816472",
  null
  
)

export default component.exports